import type { PropsWithChildren } from 'react'
import LocaleAwareRoute from 'components/App/Routes/LocaleAwareRoute'

interface Props {
  code: number
}

function HttpStatus({ code, children }: PropsWithChildren<Props>) {
  return <LocaleAwareRoute render={({ staticContext }) => {
    if (staticContext) {
      staticContext.statusCode = code
    }
    return children
  }}
  />
}

export default HttpStatus
